import React from "react";

export class RefreshButton extends React.Component {
    render() {
        var classname = "refresh-button";
        if (this.props.isLoading === true) {
            classname += " " + "fa-spin";
        }
        return (
            <a className={classname} onClick={() => this.props.onClick()}/>
        );
    }
}

export class FilterButton extends React.Component {
    render() {
        var classname = "filter-button";
        if (this.props.isActive === true) {
            classname += " " + "filter-button-active";
        }
        return (
            <a className={classname} onClick={() => this.props.onClick()}/>
        );
    }
}

